import ShaderCanvas from "../components/ShaderCanvas";
import React, { useState } from "react";

const fragShader = `
#ifdef GL_ES
precision mediump float;
#endif

uniform vec2 u_resolution;
uniform vec2 u_mouse;
uniform float u_time;

void main() {
    vec2 st = gl_FragCoord.xy / u_resolution;

    float r = 0.5 + sin(st.x * 3.0 + u_time) * 0.5;
    float g = 0.5 + sin(st.y * 3.0 + u_time + 2.0) * 0.5;
    float b = 0.5 + sin((st.x + st.y) * 3.0 + u_time + 4.0) * 0.5;

    gl_FragColor = vec4(r, g, b, 1.0);
}
`;

export default () => {
  const [live, setLive] = useState({ time: 0, resolution: [0,0], mouse: [0,0], mouseNorm: [0,0] });

  return(
    <div style = { { position: "relative", display: "flex", justifyContent: "center", gap : "16px" } }>
        <ShaderCanvas fragShader={fragShader} onFrame={(vals) => setLive(vals)} />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          <pre>
            {(() => {
              // create a copy and inject live values into uniform declarations
              let src = fragShader;
              // inject u_time as a comment after its declaration
              src = src.replace(/uniform\s+float\s+u_time\s*;/, `uniform float u_time; // ${live.time.toFixed(1)}`);
              // inject u_resolution
              src = src.replace(/uniform\s+vec2\s+u_resolution\s*;/, `uniform vec2 u_resolution; // ${live.resolution[0]} x ${live.resolution[1]}`);
              // inject u_mouse (show normalized values which are now passed as u_mouse)
              src = src.replace(/uniform\s+vec2\s+u_mouse\s*;/, `uniform vec2 u_mouse; // ${live.mouseNorm[0].toFixed(1)} , ${live.mouseNorm[1].toFixed(1)}`);
              return src;
            })()}
          </pre>
        </div>
    </div>
  );
}